import GatepassDetails from "./GatepassDetails";
import VehicleDetails from "./VehicleDetails";
import VesselDetails from "./VesselDetails";
import VisitorDetails from "./VisitorDetails";

const OffshoreGatepass = () => {
  return (
    <div data-testid="offshore-gatepass-form" className="flex flex-col gap-8">
      <VisitorDetails />
      <GatepassDetails />
      <VehicleDetails />
      <VesselDetails />
    </div>
  );
};

export default OffshoreGatepass;
